import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-2 d-flex" }
const _hoisted_2 = { class: "d-flex pt-2" }
const _hoisted_3 = { class: "form-check mx-2" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = {
  for: "model",
  class: "form-check-label"
}
const _hoisted_6 = { class: "form-check mx-2" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = {
  for: "image",
  class: "form-check-label"
}
const _hoisted_9 = { class: "form-check mx-2" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = {
  for: "movie",
  class: "form-check-label"
}
const _hoisted_12 = { class: "form-check mx-2" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = {
  for: "sound",
  class: "form-check-label"
}
const _hoisted_15 = { class: "mx-2" }
const _hoisted_16 = ["placeholder"]

import { ref, watch } from "vue";
import { translation } from "../../../lang/Translation";
import { getType } from "../../../utils/UserFile";
export interface FilterFile{
  filePath:string 
}

interface Prop {
  lows:FilterFile[],
  onFilterChanged:(filteredRows: FilterFile[], type: string)=>void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FileFilterByTypeSection',
  props: {
    lows: null,
    onFilterChanged: null
  },
  setup(__props: any) {

const props = __props as {
  lows:FilterFile[],
  onFilterChanged:(filteredRows: FilterFile[], type: string)=>void
};



const t = translation;
const imageChecked =ref(true);
const modelChecked =ref(true);
const movieChecked =ref(true);
const soundChecked =ref(true);
const textFilter = ref("")
const filter = (type:string)=>{
  const filterRow = props.lows.filter( item =>{
     const type = getType( item.filePath );
     if(modelChecked.value && type === "model") return true;
     if(imageChecked.value && type === "image") return true;
     if(movieChecked.value && type === "movie") return true;
     if(soundChecked.value && type === "sound") return true;
     return false;
  }).filter( item =>{
    if(textFilter.value.length > 0){
      return item.filePath.indexOf(textFilter.value) > 0
    }else{
      return true;
    }
  })
  props.onFilterChanged(filterRow,type);
}
const onChangeModel = ()=>{
  modelChecked.value = !modelChecked.value
  filter("model");
}
const onChangeImage = ()=>{
  imageChecked.value = !imageChecked.value
  filter("image");
}
const onChangeMovie = ()=>{
  movieChecked.value = !movieChecked.value
  filter("movie");
}
const onChangeSound = ()=>{
  soundChecked.value = !soundChecked.value
  filter("sound");
}
watch(textFilter,()=>{
  filter("text")
})

const filterTextPlaceholder = t.to("ファイル名で検索", "filter_text_placeholder")


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          id: "model",
          type: "checkbox",
          class: "form-check-input",
          value: "model",
          checked: modelChecked.value,
          onChange: onChangeModel
        }, null, 40, _hoisted_4),
        _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t).to("モデル", "filter_model")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          id: "image",
          type: "checkbox",
          class: "form-check-input",
          value: "image",
          checked: imageChecked.value,
          onChange: onChangeImage
        }, null, 40, _hoisted_7),
        _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t).to("画像","filter_image")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("input", {
          id: "movie",
          type: "checkbox",
          class: "form-check-input",
          value: "movie",
          checked: movieChecked.value,
          onChange: onChangeMovie
        }, null, 40, _hoisted_10),
        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t).to("動画","filter_movie")), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("input", {
          id: "sound",
          type: "checkbox",
          class: "form-check-input",
          value: "sound",
          checked: soundChecked.value,
          onChange: onChangeSound
        }, null, 40, _hoisted_13),
        _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t).to("音源","filter_sound")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textFilter).value = $event)),
        type: "text",
        class: "form-control",
        placeholder: _unref(filterTextPlaceholder)
      }, null, 8, _hoisted_16), [
        [_vModelText, textFilter.value]
      ])
    ])
  ]))
}
}

})